const states = {
    0: 'Normal',
    1: 'Paused',
    2: 'Complete',
    3: 'Error',
    4: 'Blocked',
    5: 'None',
};

export { states as default };